import React, { useState, useEffect } from 'react';
import ReactTable from 'react-table';
import { withRouter } from 'react-router';

import BusinessApi from 'apis/Business';
import Loading from 'utils/Loading';
import Toaster from 'components/Toaster';
import { customFormatDate } from 'utils/date';

const BillingActivity = ({ match }) => {
  const { id: businessId } = match.params;
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    BusinessApi.getBillingActivity(businessId)
      .then(({ data }) => setData(data))
      .catch(() =>
        Toaster.getErrorToaster(
          'exclamation-triangle',
          'Could not fetch billing details'
        )
      )
      .then(() => setLoading(false));
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  const columns = [
    {
      id: 'date',
      Header: 'Date',
      accessor: ({ created_at }) => customFormatDate(created_at),
    },
    {
      id: 'description',
      Header: 'Description',
      accessor: ({ description }) => description,
    },
    {
      id: 'amount',
      Header: 'Amount',
      accessor: ({ amount }) => `$${amount}`,
    },
    {
      id: 'status',
      Header: 'Status',
      accessor: ({ status }) => status,
    },
  ];

  const minRows = data.length ? 0 : 2;

  return (
    <div className="container">
      <h5>Billing History</h5>
      <div>
        <ReactTable
          className="styled-box-shadow bg-white"
          data={data}
          columns={columns}
          resizable={false}
          sortable={false}
          minRows={minRows}
          noDataText="No billing activity"
          showPagination
        />
      </div>
    </div>
  );
};

export default withRouter(BillingActivity);



// WEBPACK FOOTER //
// ./src/containers/billingActivity.js